export default "<CKEDITOR [content]=\"documentContent\" [height]=\"100\" (contentChange)=\"contentChange($event)\">\r\n</CKEDITOR>"